<p>
  代码授权方式：<a href="https://www.apache.org/licenses/LICENSE-2.0">Apache-2.0 License</a>文档授权方式：
  <a href="http://creativecommons.org/licenses/by/4.0/">CC BY 4.0</a>.
</p>
<p>当前版本 {{ versionInfo?.full }}。</p>
<!-- TODO: twitter widget (but only on pages that use twitter) -->
